import Slider from '../slider';

export default (element) => {
  let slider;
  const initSlider = () => {
    if (element.querySelector('[data-promo-slider]')) {
      slider = new Slider({
        el: element.querySelector('[data-promo-slider]'),
        options: {
          slidesPerView: 1,
          loop: true,
          mousewheel: true,
          autoplay: {
            delay: 3000,
          },
        },
      });
    }
    return slider;
  };

  const init = () => {
    if (
      document.cookie.includes('promobar=false') &&
      !window.Shopify.designMode
    ) {
      element.classList.add('hidden');
      return;
    }
    const closeBtn = element.querySelector('[data-close]');
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      element.classList.add('hidden');
      if (window.Shopify.designMode) return;
      const todayDate = new Date();
      todayDate.setDate(todayDate.getDate() + 1);
      document.cookie = `promobar=false;
      expires=${todayDate.toUTCString()};domain=${
        document.location.host
      };path=/`;
    });
    initSlider();
  };

  init();
};
